module.exports = __webpack_public_path__ + "img/banner_thick.18d6eb4a.svg";